import React from "react";
import { Typography } from "@material-ui/core";

export const PastPolls = () => {
  return <Typography>There are no past polls.</Typography>;
}